import { render, staticRenderFns } from "./pay-weixin.vue?vue&type=template&id=1bf5b648&scoped=true"
import script from "./pay-weixin.vue?vue&type=script&lang=js"
export * from "./pay-weixin.vue?vue&type=script&lang=js"
import style0 from "./pay-weixin.vue?vue&type=style&index=0&id=1bf5b648&prod&lang=scss&scoped=true"
import style1 from "./pay-weixin.vue?vue&type=style&index=1&id=1bf5b648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5b648",
  null
  
)

export default component.exports